import { accentClasses, hasPlacement } from "@/lib/urgency";
import { useUrgencyCampaign } from "@/hooks/useUrgency";
import { UrgencyCountdown } from "./UrgencyCountdown";

/**
 * Compact inline urgency note for the product price block and cart drawer.
 * Shows the campaign headline plus a live countdown to its real end time.
 */
export function UrgencyInline({
  placement,
  className = "",
}: {
  placement: "pdp" | "cart" | "home";
  className?: string;
}) {
  const campaign = useUrgencyCampaign();
  if (!campaign || !hasPlacement(campaign, placement)) return null;

  return (
    <div
      className={`flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl px-3 py-2 text-[12px] font-semibold ${accentClasses(
        campaign.accent,
      )} ${className}`}
    >
      <span>{campaign.headline}</span>
      {campaign.coupon_code ? (
        <span className="rounded-full border border-current/40 px-2 py-0.5 text-[11px]">
          {campaign.coupon_code}
        </span>
      ) : null}
      <UrgencyCountdown endsAt={campaign.ends_at} prefix="Ends in" className="ml-auto" />
    </div>
  );
}
